import { useState } from 'react';
import { Link } from 'react-router-dom';
import { MessageSquarePlus } from 'lucide-react';
import { BrandLogo } from '@/components/brand/BrandLogo';
import { FeedbackDialog } from '@/components/feedback/FeedbackDialog';

export function PublicFooter() {
  const [feedbackOpen, setFeedbackOpen] = useState(false);

  return (
    <footer className="bg-navy-900 py-10 px-5">
      <div className="max-w-[800px] mx-auto">
        <div className="mb-2">
          <BrandLogo size="sm" variant="dark" />
        </div>
        <p className="text-[13px] text-slate-400 mb-4">
          The digital home of amateur sailboat racing.
        </p>
        <div className="flex gap-4 mb-6">
          <Link to="/" className="text-[13px] text-white hover:text-brand-blue transition-colors">
            Replay
          </Link>
          <span className="text-slate-600">&middot;</span>
          <Link to="/regattas" className="text-[13px] text-white hover:text-brand-blue transition-colors">
            Regattas
          </Link>
        </div>

        {/* Data quality disclaimer + feedback link */}
        <div className="bg-[#1a3a5c] rounded-lg px-4 py-3 mb-6">
          <p className="text-[13px] text-slate-300 leading-relaxed">
            RegattaReplay does its best to capture results correctly but may have errors.
            Found something wrong?{' '}
            <button
              onClick={() => setFeedbackOpen(true)}
              className="text-brand-blue hover:text-white transition-colors font-medium inline-flex items-center gap-1"
            >
              <MessageSquarePlus size={13} />
              Let us know
            </button>
          </p>
        </div>

        <div className="border-t border-[#2d4a7a] pt-4">
          <div className="flex flex-wrap gap-4 mb-3">
            <a href="mailto:hello@regattazone.com" className="text-xs text-slate-400 hover:text-white transition-colors">
              About
            </a>
            <Link to="/privacy" className="text-xs text-slate-400 hover:text-white transition-colors">
              Privacy
            </Link>
            <Link to="/terms" className="text-xs text-slate-400 hover:text-white transition-colors">
              Terms
            </Link>
            <a href="mailto:contact@regattazone.com" className="text-xs text-slate-400 hover:text-white transition-colors">
              Contact
            </a>
            <button
              onClick={() => setFeedbackOpen(true)}
              className="text-xs text-slate-400 hover:text-white transition-colors"
            >
              Report Issue
            </button>
          </div>
          <p className="text-xs text-slate-600">
            Come sail with us.
          </p>
          <p className="text-xs text-slate-600">
            &copy; {new Date().getFullYear()} RegattaReplay
          </p>
        </div>
      </div>

      <FeedbackDialog open={feedbackOpen} onOpenChange={setFeedbackOpen} />
    </footer>
  );
}
